import React from 'react'
import DownloadDriverForm from '../DownloadDriverForm'

const HpForm = () => {
  return (
    <>
     <DownloadDriverForm
        brand="HP"
        image="https://support-printers.netlify.app/img/HP_logo_630x630.png"
      />
    </>
  )
}

export default HpForm
